export const TXTWCL_No_consecutive_spaces_are_allo_ELL = {
  "id": "TXTWCL_No_consecutive_spaces_are_allo_ELL",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "No consecutive spaces are allowed."
} as const;